
export default {
    dashboardApiAddress: import.meta.env.VITE_DASHBOARD_API_ADDRESS,
    appMode: import.meta.env.MODE,
    devApiUrl: import.meta.env.MODE !== 'test'
        ? import.meta.env.VITE_DASHBOARD_DEV_API_URL
        : 'http://localhost',
}
